import { Survey } from '../../components/Footer/Survey/Survey';

const COMPANY = 'Company';

const HOME = 'Home';
const ABOUT_US = 'About Us';
const PARTNER = 'Partner';
const CAREERS = 'Careers';

export const companyFooterList = {
  title: COMPANY,
  list: [
    {
      href: '/',
      text: HOME,
    },
    {
      href: '/about',
      text: ABOUT_US,
    },
    {
      href: '/partner',
      text: PARTNER,
    },
    {
      href: '/careers',
      text: CAREERS,
    },
  ],
};

const LINKS_AND_SUPPORT = 'Links and Support';

const CONTACT_US = 'Contact Us';
const BLOGS = 'Blogs';
const FAQ = 'FAQ';
const SURVEY = 'Survey';

export const linksAndSupportFooterList = {
  title: LINKS_AND_SUPPORT,
  list: [
    {
      href: '/contact',
      text: CONTACT_US,
    },
    {
      href: '/blogs',
      text: BLOGS,
    },
    {
      href: '/survey',
      text: SURVEY,
    },
    {
      href: '/faq',
      text: FAQ,
    },
  ],
};

const LEGAL = 'Legal';
const PRIVACY_POLICY = 'Privacy Policy';
const TERMS_OF_SERVICE = 'Terms Of Service';

export const legalFooterList = {
  title: LEGAL,
  list: [
    {
      href: '/privacy_policy',
      text: PRIVACY_POLICY,
    },
    {
      href: '/terms_of_service',
      text: TERMS_OF_SERVICE,
    },
  ],
};

export const SOCIAL_MEDIA = 'Social Media';

export const CashCleverCopyRight = '© 2026 CashClever, Corp., All Rights Reserved.';
